import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import Input from '../../../../components/form/Input'
import Text, { Label } from '../../../../packages/kiti/components/presentation/Text'

const GeneralSection = () => {
  const { t } = useTranslation('editMasks')
  const form = useForm()

  const { handleChange } = useFormState()
  const maskAtPlayground = form.pattern ? t('applied', { pattern: form.pattern }) : ''

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('name')} field="name" />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label={t('pattern')} field="pattern" />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label={`${t('playground')} ${maskAtPlayground}`} field="test">
          <Input
            masks={[form.pattern]}
            value={form.test}
            onBlur={handleChange('test')}
            onStopTyping={handleChange('test')}
          />
        </FormItem>
      </Col>
    </Grid>
  )
}

export default GeneralSection
